module.exports = __webpack_public_path__ + "bb725d25.png";